import React, { Component } from 'react'
import { connect } from 'react-redux'
import BackButton from '../../../../elements/BackButton'
import Select from 'react-select'
import { getTeacherSchoolData } from "../../../../redux/Teacher/user/action"
import { Form, FormControl, InputGroup } from 'react-bootstrap';
import Modal from "react-modal";
import { CgCheckO } from 'react-icons/cg'
import { addRemark } from "../../../../redux/Teacher/student/action"
export class AddReview extends Component {
    state = {
        loading: false,
        remark: [],
        stdnt_class: '',
        sections: [],
        subjects: [],
        students: [],
        open: false,
    };
    componentDidMount() {
        const { teacher } = this.props
        this.props.getTeacherSchoolData(teacher.data.auth_token)
    }
    onSubmit = (e) => {
        e.preventDefault();
        const { teacher } = this.props;
        const { remark } = this.state;
        let formData = new FormData();
        formData.append("student_id", remark.student_id)
        formData.append("remark", remark.remark)
        formData.append("token", teacher.data.auth_token)
        this.props.addRemark(formData).then((response) => {
            if (response?.data?.success) {
                this.modalOpen()
                document.getElementById('remarkform').reset();
            }
        })
    }
    getSections = (val) => {
        const { schooldata } = this.props;
        const stdnt_class = schooldata?.data?.student_classes?.find((data) => data.id == val)
        const sections = stdnt_class?.sections?.map((section) => ({
            value: section.id,
            label: section.name
        }))
        this.setState({ sections: sections, stdnt_class: stdnt_class, students: [] })
    }
    getStudents = (val) => {
        const { stdnt_class } = this.state;
        const section_students = stdnt_class?.students?.filter((usr) => usr.section_id == val)
        const students = section_students?.map((usr) => ({
            value: usr.id,
            label: usr?.user?.name
        }))
        this.setState({ students: students })
    }
    handleInput(e, name) {
        let data = this.state.remark;
        data[name] = e;
        this.setState({ remark: data });
    }
    modalOpen = () => {
        this.setState({ open: true });
    };
    modalClose = () => {
        this.setState({ open: false });
    };
    render() {
        const { schooldata } = this.props;
        const { sections, students } = this.state;
        const classes = schooldata?.data?.student_classes?.map((data) => ({
            value: data.id,
            label: data.name
        }))
        return (
            <React.Fragment>
                <BackButton title={"Add Review"} />
                <Form onSubmit={this.onSubmit} id="remarkform">
                    <div className='px-3 mt-4'>
                        <div className="mt-3">
                            <Select className="text-muted attendence-input px-2" placeholder='Class' styles={customStyles} options={classes}
                                onChange={e => {
                                    let value = e.value;
                                    this.handleInput(value, "class_id");
                                    this.getSections(value);
                                }} />
                        </div>
                        <div className="mt-3">
                            <Select className="text-muted attendence-input px-2" placeholder='Section' styles={customStyles} options={sections}
                                onChange={e => {
                                    let value = e.value;
                                    this.handleInput(value, "section_id");
                                    this.getStudents(value);
                                }} />
                        </div>
                        <div className="mt-3">
                            <Select className="text-muted attendence-input px-2" placeholder='student' styles={customStyles} options={students}
                                onChange={e => {
                                    let value = e.value;
                                    this.handleInput(value, "student_id");
                                }} />
                        </div>
                        <div className="mt-3">
                            <InputGroup hasValidation className="mt-2 attendence-input" style={{ boxSizing: 'border-box' }} >
                                <FormControl
                                    type="text"
                                    placeholder="Comment"
                                    className="attendence-input"
                                    onChange={e => {
                                        let value = e.target.value;
                                        this.handleInput(value, "remark");
                                    }}
                                    required
                                />
                            </InputGroup>
                        </div>
                    </div>
                    <div className='position-fixed bottom-0 py-2 w-100 px-3'>
                        <button className='btn attendence-dwld-btn mt-2 py-3 w-100' >
                            Submit
                        </button>
                    </div>
                </Form>
                <Modal
                    isOpen={this.state.open}
                    ariaHideApp={false}
                    onRequestClose={() => this.modalClose()}
                    style={modalStyles}
                    contentLabel="Example Modal"
                >
                    <div
                        className="container"
                        style={{
                            borderRadius: "5px",
                            height: "70vw",
                            width: '70vw',
                            zIndex: "9999",
                        }}
                    >
                        <React.Fragment>
                            <div className="d-flex flex-column justify-content-center align-items-between">
                                <div className='d-flex justify-content-center mt-5'
                                    style={{ fontSize: '18px', fontWeight: '600', color: '#2B2C2F' }}>
                                    <CgCheckO color={"#7ECB40"} size={"4em"} />
                                </div>
                                <div className='d-flex justify-content-center mt-4'
                                    style={{ fontSize: '15px', fontWeight: '400', color: '#2B2C2F' }}>
                                    Remark Added Successfully</div>
                                <div className='d-flex justify-content-between w-100 position-fixed' style={{ bottom: '20%', left: '0%' }}>
                                </div>
                            </div>
                        </React.Fragment>
                    </div>
                </Modal>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    teacher: state.teacher.teacher,
    schooldata: state.teacher.schooldata,
})

export default connect(mapStateToProps, { getTeacherSchoolData, addRemark })(AddReview)
const customStyles = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: '#fff',
        border: 'none', // tried border: 'none'
        boxShadow: 'none', // tried border: 'none'
        outline: 'none',

    }),
    control: (provided) => ({
        ...provided,
        height: "50px",
        width: "88vw",
        border: "none",
        boarderRadius: "10px",
        fontSize: '13px',
        borderStyle: 'none',
        background: 'rgba(190, 175, 179, 0.05)',
        outline: 'none',
        fontWeight: '400',
        lineHeight: '14px',
        letterSpacing: '1px',
        color: '#86878E',
    })

}
const modalStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-38%",
        border: "2px solid #C24A6B",
        transform: "translate(-50%, -50%)",
        borderRadius: "15px",
    },
};
